import React from 'react'
import { Link } from 'gatsby'
import { DateTime } from 'luxon'

const PostInfo = ({ className, author, category, publishAt }) => {
  const formattedDate = DateTime.fromISO(publishAt).toLocaleString(
    DateTime.DATETIME_MED
  )

  return (
    <div className={className || 'post-info'}>
      Posted in <RenderCategory category={category} /> by{' '}
      <RenderAuthor author={author} />, {formattedDate}
    </div>
  )
}

const RenderCategory = ({ category }) => {
  if (!category?.slug?.current)
    return <strong>{category?.name || 'Unknown'}</strong>

  return (
    <Link to={`/archive?category=${category.slug.current}`}>
      <strong>{category.name}</strong>
    </Link>
  )
}

const RenderAuthor = ({ author }) => {
  if (!author?.slug?.current)
    return <strong>{author?.name || 'Unknown'}</strong>

  return (
    <Link to={`/archive?author=${author.slug.current}`}>
      <strong>{author.name}</strong>
    </Link>
  )
}

export default PostInfo
